var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.699,
    height: 44.649,
    viewBox: "0 0 48.699 44.649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "searchicon",
    transform: "matrix(0.087, 0.996, -0.996, 0.087, 45.138, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16917",
    "data-name": "Path 16917",
    d: "M24.945,22.945Zm0-8.945",
    transform: "translate(-10.474 -7.234)",
    fill: "#1f54cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16919",
    "data-name": "Path 16919",
    d: "M47.8,43.084l-7.446-8.595a1.756,1.756,0,0,0-2.423-.211L35.817,36l-3.51-4.353a14.92,14.92,0,0,0,4.627-10.827A14.662,14.662,0,0,0,22.467,6,14.664,14.664,0,0,0,8,20.817,14.661,14.661,0,0,0,22.467,35.63a14.155,14.155,0,0,0,8.527-2.873l3.487,4.323L32.47,38.717a1.732,1.732,0,0,0-.219,2.478l7.45,8.595a4.5,4.5,0,0,0,6.19.531l1.366-1.11a4.265,4.265,0,0,0,.545-6.127ZM9.7,20.817A12.938,12.938,0,0,1,22.467,7.743,12.938,12.938,0,0,1,35.232,20.817a12.935,12.935,0,0,1-12.765,13.07A12.938,12.938,0,0,1,9.7,20.817ZM43.719,41l-5.5,4.473-2.39-2.747,5.508-4.476Zm-4.727-5.354a.06.06,0,0,1,.043-.014.071.071,0,0,1,.046.017l2.254,2.6-5.518,4.476-2.29-2.641Zm7.207,12.2-1.37,1.11a2.8,2.8,0,0,1-3.856-.323L38.217,45.47,43.719,41l2.809,3.244a2.483,2.483,0,0,1,.612,1.848A2.518,2.518,0,0,1,46.2,47.846Zm0,0",
    transform: "translate(-7.996 -6)",
    fill: "#1f54cc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.0b27b0c86757c099a4fb640874c9e428.svg";
export { ForwardRef as ReactComponent };